/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPoolsApplet} from '../api'

 export const useQueryGetPoolsApplet = createReactQueryHook('getPoolsApplet', getPoolsApplet)
